import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Features } from '../components/sections/Features';
import { SocialProof } from '../components/sections/SocialProof';
import { ProblemSolution } from '../components/sections/ProblemSolution';
import { CourseDetails } from '../components/sections/CourseDetails';
import { FooterCTA } from '../components/sections/FooterCTA';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
export function Landing() {
  return <main className="min-h-screen bg-bg-primary text-text-primary" data-id="element-296">
      <Hero data-id="element-297" />
      <Features data-id="element-298" />
      <SocialProof data-id="element-299" />
      <ProblemSolution data-id="element-300" />
      <CourseDetails data-id="element-301" />
      <FooterCTA data-id="element-302" />
      <PurchaseNotifications data-id="element-303" />
    </main>;
}